import { gql } from '@apollo/client';

export const UPDATE_EXTRA_ACTIVITY_ASSIGNMENT = gql`
	mutation updateExtraActivityAssignment(
		$input: WorkAssignmentExtraActivityUpdateInput!
		$overlappingActivityAction: OverlappingActivityAction
		$delayMinutes: Int
	) {
		updateExtraActivityAssignment(
			input: $input
			overlappingActivityAction: $overlappingActivityAction
			delayMinutes: $delayMinutes
		) {
			__typename
			... on WorkAssignmentExtraActivitySuccessResponse {
				workAssignmentSequence {
					isMultiRide
					sequenceGroupId
					rideId
					crewMember {
						id
						fullName
					}
					fromStation {
						id
						name
						code
					}
					toStation {
						id
						name
						code
					}
					fromTimestamp
					toTimestamp
					activityType
					status
					workAssignments {
						crewMember {
							id
							fullName
						}
						status
						version
						id
						fromStation {
							id
							name
						}
						toStation {
							id
							name
						}
					}
					run {
						name
						id
					}
					job {
						id
						code
						runId
					}
					extraActivities {
						fromTimestamp
						toTimestamp
						id
						version
						status
						fromStation {
							id
							code
							timezone
						}
						toStation {
							id
							code
							timezone
						}
						activityType
					}
				}
			}
			... on WorkAssignmentExtraActivityErrorResponse {
				errors
			}
			... on WorkAssignmentOverlappingActivitiesResponse {
				overlappingActivities {
					fromTimestamp
					toTimestamp
					isCancellable
					activity {
						... on CrewMemberWorkAssignmentActivityItem {
							title
							rideId
							deadheadId
							activityType
							status
							fromStation {
								id
								name
								code
								timezone
							}
							toStation {
								id
								name
								code
								timezone
							}
							note
							run {
								id
								name
							}
							job {
								id
								code
							}
						}
						... on CrewMemberAbsenceActivityItem {
							reason {
								id
								name
							}
							note
						}
						... on CrewMemberBreakActivityItem {
							breakType
						}
					}
				}
				minDelayMinutes
				maxDelayMinutes
			}
		}
	}
`;
